import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

// Shadcn/ui components
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import LoadingSpinner from "../../loading-spinner/LoadingSpinner";

export default function SignupForm() {
  const { signup, loading, resendCode } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await signup(email, password);
      
      localStorage.setItem("mb_userEmail", email);
      navigate("/confirm", { state: { username: email } });

    } catch (err) {
      
      if (err.name === "UsernameExistsException") {
        try {
          
          await resendCode(email);
          alert("An account with this email already exists but is not confirmed. A new confirmation code has been sent to your email.");
          navigate("/confirm", { state: { username: email } });
        } catch (resendErr) {
          
          alert("An account with this email already exists. Please sign in.");
          navigate("/login");
        }
      } else {
        alert(err.message);
      }
    }
  };


   if (loading) {
      return (
        <div className="p-4 flex items-center justify-center min-h-[40vh]">
          <LoadingSpinner />
        </div>
      );
    }

  return (
    <div className="h-[calc(100vh-40px)] flex items-center justify-center px-4">
      <div className="mx-auto w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">Sign Up</h1>
          <p className="text-sm text-muted-foreground">
            Enter your email and password to create your account
          </p>
        </div>
        <form onSubmit={handleSignup} className="space-y-4">
          <div className="space-y-1">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="w-full" disabled={loading}>
            Sign Up
          </Button>
        </form>
        <p className="px-8 text-center text-sm text-muted-foreground">
          Already have an account?{' '}
          <Link to="/login" className="underline underline-offset-4">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
